<template lang="html">
  <div class="members"
    v-loading="loading">
    <el-table
      :data="members.list"
      style="width: 100%"
      v-if="members !== null"
      :loading="loading" border stripe>
      <span>{{members}} </span>
      <el-table-column
        prop="user.name"
        :label="$t('name')">
      </el-table-column>
      <el-table-column
        :label="$t('confirmation_status')">
        <template slot-scope="scope">
          <el-tag
          :type="scope.row.user.confirmation_status === 'confirmed' ?
            'success' : 'danger'"
          class="no-margin">
            {{ $t(scope.row.user.confirmation_status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        width="280"
        :label="$t('tools')"
        align="right">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('customers')"
            placement="top-start">
            <router-link
              :to="{ name: 'customer-teams', params: {id: scope.row.user.id}, query:{name: scope.row.name} }"
              class="el-button el-button--info el-button--mini is-plain">
              <i class="fas fa-user-tag"></i>
            </router-link>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('teams')"
            placement="top-start">
              <router-link
                :to="{ name: 'user', params: {id: scope.row.user.id} }"
                class="el-button el-button--info el-button--mini is-plain">
                <i class="fas fa-users"></i>
              </router-link>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('sign_in_to_user_panel')"
            placement="top-start">
            <el-button
              size="mini"
              type="info"
              plain
              @click="autoLoginToClientPanel(scope.row)">
              <i class="fas fa-sign-in-alt"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="total>limit"
      style="marginTop:1rem"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="limit"
      :current-page.sync="currentPage">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      members: null,
      loading: false,
      limit: 10,
      currentRow: 0,
      user: null,
      currentPage: 1,
      query: {},
      total: 0
    }
  },
  computed: {
    offset () {
      return (this.currentPage - 1) * this.limit
    }
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    getMembers () {
      const { toggleLoading, $route, limit, offset, query } = this
      this.handleRequest({
        name: `trace_tokens/${$route.params.lid}/users`,
        action: 'getAll',
        data: {
          query: {
            limit,
            offset,
            ...query
          }
        }
      }).then((res) => {
        this.members = res
        this.total = res.total
      })
        .finally(toggleLoading)
    },
    setData (res) {
      this.traceToken = res
      this.getMembers()
    },
    getData () {
      const { toggleLoading, setData, $route } = this
      toggleLoading()
      this.handleRequest({
        name: 'trace_tokens',
        action: 'getOne',
        data: {
          id: $route.params.lid
        }
      }).then(setData)
    },
    redirectUserToClientPanel (res) {
      const { link } = res
      const url = `https://${process.env.VUE_APP_SERVER_URL}/#/autologin?link=${link}?operator_id=${this.self.id.numberStr}`
      window.open(url, '_blank')
    },
    handleAuthSuccess (res, user) {
      localStorage.setItem('server_access_token', res.access_token)
      const { domainsPath } = this
      const clientID = process.env.VUE_APP_CLIENT_ID
      const name = `${domainsPath}/clients/${clientID}/users/${user.user.id.numberStr}/links/oauth`
      this.handleRequest({
        name,
        action: 'getAll',
        tokenScope: 'server'
      }).then(this.redirectUserToClientPanel)
        .finally(this.toggleLoading)
    },
    autoLoginToClientPanel (user) {
      let data = new FormData()
      data.append('grant_type', 'client_credentials')
      data.append('client_id', process.env.VUE_APP_SERVER_CLIENT_ID)
      data.append('client_secret', process.env.VUE_APP_SERVER_CLIENT_SECRET)
      this.toggleLoading()
      this.handleRequest({
        name: 'auth/token',
        action: 'create',
        data
      }).then(res => {
        this.handleAuthSuccess(res, user)
      })
    }
  },
  watch: {
    currentPage () {
      this.getData()
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="css">
</style>
